import { SET_SECTION } from "../actions/constantes";

const setSection = (payload) => {
    return{
        type: SET_SECTION,
        payload
    }
};

export default setSection;